export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const MOBILE = 'mobile';
import { DesktopIcon, TabletIcon, MobileIcon } from 'foundations-assets';
export const PREVIEW_WIDTHS = {
  [DESKTOP]: 'inherit',
  [TABLET]: '826px',
  [MOBILE]: '520px'
};
export const BREAKPOINT_ICONS = {
  [DESKTOP]: DesktopIcon,
  [TABLET]: TabletIcon,
  [MOBILE]: MobileIcon
};
export const CUSTOM_BREAKPOINT_ICON = 'cssFile';